import { applyMiddleware, compose, createStore } from 'redux';
import { routerMiddleware } from 'react-router-redux';
import thunk from 'redux-thunk';
import rootReducer from './rootReducer';
import * as variables from '../frilans-finans/variables';

export default function configureStore (initialState = {}, history) {
  // Compose final middleware and use devtools in debug environment
  let middleware = [
    thunk,
    routerMiddleware(history)
  ];

  if (process.env.NODE_ENV === 'production') {
    let RavenMiddleware = require('redux-raven-middleware');

    let raven = RavenMiddleware(
      variables.sentryDsn,
      {
        release: 'account-web:' + variables.version,
        environment: variables.appEnv
      }
    );

    middleware = [ ...middleware, raven ];
  }

  middleware = applyMiddleware(...middleware);

  if (__DEBUG__) {
    const devTools = window.devToolsExtension
      ? window.devToolsExtension()
      : require('containers/DevTools').default.instrument();
    middleware = compose(middleware, devTools);
  }

  // Create final store and subscribe router in debug env ie. for devtools
  var store;
  if (process.env.NODE_ENV) {
    store = middleware(createStore)(
      rootReducer,
      initialState,
      window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__());
  } else {
    store = middleware(createStore)(rootReducer, initialState);
  }

  if (module.hot) {
    module.hot.accept('./rootReducer', () => {
      const nextRootReducer = require('./rootReducer').default;

      store.replaceReducer(nextRootReducer);
    });
  }
  return store;
}



/** WEBPACK FOOTER **
 ** ./src/redux/configureStore.js
 **/